
import { Layout } from 'ant-design-vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'page-layout',
  components: {
    'a-layout': Layout,
  },
});
